export const TreeConfig = {
    "core": {
        "animation": false,
        "multiple": false
    },

    "search": {
        "depthFirst": true,
        "close_opened_onclear": false
    },

    "contextmenu": {
        "select_node": false,
        "show_at_node": false
    },

    "plugins": ["search", "types", "contextmenu", "sort"],

    "types": {
        "#": {
            icon: "icon icon-generic"
        },
        maven: {
            icon: "icon icon-pom"
        },
        docker: {
            icon: "icon icon-docker"
        },
        nuget: {
            icon: "icon icon-nuget"
        },
        npm: {
            icon: "icon icon-npm"
        },
        bower: {
            icon: "icon icon-bower"
        },
        pypi: {
            icon: "icon icon-pypi"
        },
        rubygems: {
            icon: 'icon icon-rubygems'
        },
        ruby: {
            icon: 'icon icon-rubygems'
        },
        yum: {
            icon: "icon icon-yum"
        },
        rpm: {
            icon: "icon icon-rpm"
        },
        debian: {
            icon: "icon icon-deb"
        },
        deb: {
            icon: "icon icon-deb"
        },
        generic: {
            icon: "icon icon-general"
        },
        build: {
            icon: "icon icon-build"
        },
        alpine: {
            icon: "icon icon-alpine"
        },
        "default": {
            icon: "icon icon-general"
        }
    }

};


/*
 Maven -
 class="icon icon-pom"

 Docker -
 class="icon icon-docker"

 NuGet -
 class="icon icon-nuget"

 npm -
 class="icon icon-npm"

 bower -
 class="icon icon-bower"

 pypi -
 class="icon icon-pypi"

 yum -
 class="icon icon-yum"

 debian -
 class="icon icon-deb"

 generic -
 class="icon icon-generic"
 */


// WEBPACK FOOTER //
// ./modules/xray/directives/jf_component_tree/jf_component_tree.config.js